import { createServiceTag } from "./tokens.js";
//#region src/sdk/tags.ts
var SDK_SERVICE_TAGS = {
	PAGE_ROUTER: createServiceTag("sdk.page-router"),
	CACHE_REVALIDATION_ADAPTOR: createServiceTag("sdk.cache-revalidation-adaptor"),
	CMS_CONTENT_CHANGE_TRANSLATOR: createServiceTag("sdk.cms-content-change-translator"),
	CONTENT_REVALIDATION_PLANNER: createServiceTag("sdk.content-revalidation-planner")
};
//#endregion
export { SDK_SERVICE_TAGS };

//# sourceMappingURL=tags.js.map